module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    attrs: {
      "id": "spinner"
    }
  }, [_c('div', {
    staticClass: "loading-spinner"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-718baeb1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 371
// module chunks = 1